/* @flow */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import glamorous from 'glamorous';
import { first } from 'lodash/fp';

import Notification from 'app/components/notifications/Notification';
import NotificationHandler from 'app/components/notifications/NotificationHandler';
import t from 'app/utils/translate';
import RenderFirst from '../util/RenderFirst';
import ChallengeCountdownNotification from './ChallengeCountdownNotification';

type Props = {
  entryCount: number,
  entryCap: number,
  errorMessages: Array<string>,
  hasUserEntry: boolean,
  isSubmitting: boolean,
  isUnlimited: boolean,
  isUpdating: boolean,
  startTime: number,
  isRestricted?: boolean
};

type State = {
  hasSubmitted: boolean,
  randomLineUp?: Array<Object>,
  willSubmit: boolean,
  willUpdate: boolean,
  showRestricted?: boolean
};

const StyledLink = glamorous(Link)(({ theme }) => ({
  color: theme.color.primary
}));

const defaultProps = {
  isRestricted: false
};

class OpenChallengeNotifications extends Component<Props, State> {
  props: Props;

  constructor(props: Props) {
    super(props);

    this.state = {
      showRestricted: props.isRestricted
    };
  }

  handleCloseRestricted = () => {
    this.setState({ showRestricted: false });
  };

  render() {
    const {
      entryCount,
      entryCap,
      errorMessages,
      hasUserEntry,
      isSubmitting,
      isUnlimited,
      isUpdating,
      startTime
    } = this.props;

    const { showRestricted } = this.state;

    const hasError = errorMessages.length > 0;

    return (
      <React.Fragment>
        {showRestricted && (
          <Notification type="danger" onClose={this.handleCloseRestricted}>
            {t('Your account does not meet the criteria for entry into this contest.')}
          </Notification>
        )}
        <NotificationHandler
          afterCond={!isSubmitting && hasError}
          beforeCond={isSubmitting}
          persist={hasError}
          type="danger"
        >
          <span>
            Your submission failed
            <br />
            {first(errorMessages)}
          </span>
        </NotificationHandler>
        <NotificationHandler
          afterCond={!isUpdating}
          beforeCond={isUpdating}
          persist={hasError}
          type={hasError ? 'danger' : 'success'}
        >
          {hasError ? (
            <span>
              Your submission failed
              <br />
              {first(errorMessages)}
            </span>
          ) : (
            t('Your lineup has been successfully updated')
          )}
        </NotificationHandler>
        <RenderFirst>
          {entryCount >= entryCap && !isUnlimited && !hasUserEntry && (
            <Notification persist type="danger">
              {t('Challenge')} FULL - Back to <StyledLink to="/lobby">Lobby</StyledLink>
            </Notification>
          )}
          <ChallengeCountdownNotification startTime={startTime} onClose={this.closeCountdown} />
        </RenderFirst>
      </React.Fragment>
    );
  }
}

OpenChallengeNotifications.defaultProps = defaultProps;

function mapStateToProps(state: GlobalState) {
  const { challenge, entry, lineUp } = state;

  return {
    entryCap: challenge.entryCap,
    entryCount: challenge.entryCount,
    errorMessages: lineUp.errorMessages,
    hasUserEntry: !!entry.myEntry.id,
    isSubmitting: lineUp.isSubmitting,
    isUnlimited: challenge.isUnlimited,
    isUpdating: lineUp.isUpdating,
    startTime: challenge.startTime
  };
}

export default connect(mapStateToProps)(OpenChallengeNotifications);
